import React, { Component, useState } from 'react';
import Collapse from 'react-collapse';

function CardHeader({ header }) {
  return (
    <div className='card-header bg-success'>
      <h2 className='my-0 text-white'>{header}</h2>
    </div>
  );
}

function CardSubHeader({ header, bgColor = 'secondary', textColor = 'black' }) {
  return (
    <div className={`card-header bg-${bgColor}`}>
      <h3 className={`my--1 text-${textColor}`}>{header}</h3>
    </div>
  );
}

function CardSubHeaderWithCollapse({
  header,
  bgColor = 'secondary',
  textColor = 'black',
  children
}) {
  const [isOpened, setIsOpened] = useState(false);
  return (
    <>
      <div
        className={`card-header bg-${bgColor}`}
        onClick={() => setIsOpened(!isOpened)}>
        <h3 className={`d-inline my--1 text-${textColor}`}>{header}</h3>
        {/* <div
        className='btn btn-icon btn-primary btn-sm float-right my--1'
        onClick={ () => {} }> */}
        <i
          className={`ni ni-bold-${isOpened ? 'up' : 'down'} float-right mt-2`}
          style={{ fontSize: '15px', color: 'black' }}></i>
        {/* </div> */}
      </div>
      <Collapse isOpened={isOpened}>{children}</Collapse>
    </>
  );
}

function CardSubHeaderWithCLose({ header, onClose }) {
  return (
    <div className='card-header bg-success'>
      <h3 className='d-inline my--1 text-white'> {header} </h3>
      <div
        className='btn btn-icon btn-danger btn-sm float-right my--1'
        onClick={onClose}>
        <i
          className='ni ni-fat-remove'
          style={{ fontSize: '25px', color: 'white' }}></i>
      </div>
    </div>
  );
}

function CardModuleHeader({ header }) {
  return (
    <div className='card-header bg-success'>
      <h4 className='my--2 text-white'>{header}</h4>
    </div>
  );
}

function CardBody({ children }) {
  return <div className='card-body'>{children}</div>;
}

class Card extends Component {
  static Header = CardHeader;
  static SubHeader = CardSubHeader;
  static SubHeaderWithCLose = CardSubHeaderWithCLose;
  static SubHeaderWithCollapse = CardSubHeaderWithCollapse;
  static ModuleHeader = CardModuleHeader;
  static Body = CardBody;
  render() {
    const { children, marginTop } = this.props;
    return <div className={`card mt-${marginTop}`}>{children}</div>;
  }
}

export default Card;
